const OVERLAY_IPV4 = /^100\./;
const OVERLAY_TS_NET = /\.ts\.net$/i;

export function isOverlayHostname(hostname: string): boolean {
  const host = String(hostname || "").trim().toLowerCase();
  return OVERLAY_IPV4.test(host) || OVERLAY_TS_NET.test(host);
}

export function resolveEegUploadApiBaseUrl(input: {
  defaultBaseUrl: string;
  publicUploadOrigin?: string | null;
  pageHostname?: string;
}): string {
  const fallback = String(input.defaultBaseUrl || "/api").trim() || "/api";
  const publicOrigin = String(input.publicUploadOrigin || "")
    .trim()
    .replace(/\/$/, "");
  if (!publicOrigin || !isOverlayHostname(input.pageHostname || "")) {
    return fallback;
  }
  if (/\/api$/i.test(publicOrigin)) return publicOrigin;
  return `${publicOrigin}/api`;
}
